export default __webpack_public_path__ + "static/media/pgmico(24).4aebba22.png";